import React from "react";

export function useArchiveIds(
    oneShop: boolean,
    fidelityData: { data?: Array<{ Id: string }> } | undefined
): string[] {
    return React.useMemo(() => {
        if (oneShop) return [];
        const ids = new Set<string>();
        if (fidelityData?.data) {
            for (const el of fidelityData.data) {
                ids.add(el.Id);
            }
        }
        return [...ids];
    }, [oneShop, fidelityData]);
}
